const loootyLoaderGif = "/assets/image/loader/Loooty-loader.gif"
const LoootyLoader = () => {
    return (<div className="loooty__loader-container">
        <img className="loooty__loader" src={loootyLoaderGif} alt="loader gif" />
    </div>)
}

export default LoootyLoader